<div></div>

<style>
    div {
        border-bottom: 1px dashed var(--text-disabled);
        margin: 2rem 0;
    }
</style>